module.exports = __webpack_public_path__ + "static/media/Screenshot_app_2.2b21dc1b.png";